import { useMutation } from '@tanstack/react-query';
import { post } from 'api/base';

type SendFeedbackPayload = {
  interactionId?: string;
  isHelpful: boolean;
  problems?: string[];
  note?: string;
  triggerType: 'manual' | 'automatic';
};

type SendFeedbackResponse = {
  id: number;
  interactionId: string | null;
  isHelpful: boolean;
  problems: string[];
  note: string;
  triggerType: 'manual' | 'automatic';
  createdAt: string;
  updatedAt: string;
};

export const useSendFeedback = (
  onSuccess?: (data: SendFeedbackResponse) => void,
  onError?: (error: Error) => void
) => {
  return useMutation({
    mutationFn: (payload: SendFeedbackPayload) =>
      post('sendFeedback', payload) as Promise<SendFeedbackResponse>,
    onSuccess,
    onError,
  });
};
